module.exports = __webpack_public_path__ + "img/image_42.9609157f.png";